export const FlipCardsCmsData = {
  id: "flip-cards",
  type: "FLIPCARDS",
  config: [
    {
      productType: "GENRE"
    }
  ],
  background: "#FFF",
  title: {
    content: "Stream DIRECTV your way — plans starting at a price you'll love",
    color: "#102641",
    variant: "h2"
  },
  cards: [
    {
      config: {
        id: "ATT_TV_MYENTERTAINMENT",
        queryparam: "myentertainment",
        defaultCard: "front"
      },
      frontCard: {
        background: "radial-gradient(78.39% 105.63% at 100% 97.58%, #DFEDFF 0%, rgba(223, 237, 255, 0.00) 100%), #EDF2F7",
        image: {
          url: {
            mobile: "/assets/content/ltduvhenhe/web/entMflip.png",
            tablet: "/assets/content/dhguy8fvti/web/entTV.png",
            default: "/assets/content/dhguy8fvti/web/entTV.png"
          },
          alt: "MyEntertainment-Channel-Banner",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%"
          },
          height: {
            xs: "auto",
            sm: "auto",
            md: "auto"
          },
          objectFit: {
            xs: "cover",
            sm: "cover",
            md: "cover"
          }
        },
        mobileImagePosition: "right",
        title: {
          content: "[package_name]®",
          color: "#102641",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "Hit movies & top shows — all in one easy-to-love pack.",
          color: "#102641",
          variant: "smalltext",
          fontSize: "14px"
        },
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#102641",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#102641"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/myentertainment",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      backCard: {
        borderRadius: "24px 24px 0 0",
        background: "radial-gradient(circle farthest-corner at top left, #092C5C, #000000)",
        title: {
          content: "[package_name]®",
          color: "#FFFFFF",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "",
          color: "#FFFFFF",
          variant: "smalltext",
          fontSize: "14px",
          cta: {
            label: "[channel_count]+ channels",
            modalType: "iframe",
            modalData: { url: "/channel-pack-lineup/modal?pkg=myentertainment" },
            variant: "uxlink",
            sx: {
              color: "#FFFFFF",
              fontSize: "14px",
              textDecoration: "underline",
              p: 0
            }
          }
        },
        images: [
          {
            alt: "BBQ Brawl, It's Always Sunny, Home Town, Real Housewives",
            url: {
              mobile: "/assets/content/aegltzdbli/svg/GrowCard-Logos-MBL-MyEnt-2x-v2.svg",
              tablet: "/assets/content/rpnls4cczf/svg/GrowCard-Logos-DSK-MyEnt-2x-v2.svg",
              default: "/assets/content/rpnls4cczf/svg/GrowCard-Logos-DSK-MyEnt-2x-v2.svg"
            },
            width: {
              xs: "78%",
              sm: "100%",
              md: "100%"
            },
            height: {
              md: "auto",
              sm: "auto",
              xs: "auto"
            },
            objectFit: {
              md: "contain",
              sm: "contain",
              xs: "contain"
            },
            padding: {
              xs: "0 16px",
              sm: "0 16px",
              md: "0 24px"
            },
            display: {
              xs: "flex",
              sm: "flex",
              md: "flex"
            }
          },
          {
            alt: "Programming tiles for BBQ Brawl, It's Always Sunny in Philadelphia, Home Town, and Real Housewives.",
            url: {
              mobile: "/assets/content/5mxgnnvw5t/web/entertainment1.png",
              tablet: "/assets/content/5mxgnnvw5t/web/entertainment1.png",
              default: "/assets/content/5mxgnnvw5t/web/entertainment1.png"
            },
            width: {
              md: "100%",
              sm: "100%",
              xs: "90%"
            },
            height: {
              md: "auto",
              sm: "auto",
              xs: "auto"
            },
            objectFit: {
              md: "cover",
              sm: "cover",
              xs: "cover"
            },
            display: {
              xs: "none",
              sm: "flex",
              md: "flex"
            }
          }
        ],
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#FFFFFF",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#FFFFFF"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/myentertainment",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        svods: [
          {
            code: "BOLT-DUOBASIC-202411",
            name: "Hulu",
            logo: {
              mobile: "/assets/content/fh8yeao1f8/svg/SVOD-app-logo_Hulu.svg",
              tablet: "/assets/content/fh8yeao1f8/svg/SVOD-app-logo_Hulu.svg",
              default: "/assets/content/fh8yeao1f8/svg/SVOD-app-logo_Hulu.svg"
            }
          },
          {
            code: "BOLT-DISNEYBASIC-202411",
            name: "Disney+",
            logo: {
              mobile: "/assets/content/hhnhlny9ca/svg/SVOD-app-logo_Disney-plus.svg",
              tablet: "/assets/content/hhnhlny9ca/svg/SVOD-app-logo_Disney-plus.svg",
              default: "/assets/content/hhnhlny9ca/svg/SVOD-app-logo_Disney-plus.svg"
            }
          }
        ]
      },
      compareBox: {
        content: "Compare",
        color: "#566578",
        selectedColor: "#0062DB",
        background: "#FAFCFF",
        variant: "smalltextmedium",
        fontSize: "14px !important"
      }
    },
    {
      config: {
        id: "ATT_TV_MYSPORTS",
        queryparam: "mysports",
        defaultCard: "front"
      },
      frontCard: {
        background: "radial-gradient(78.39% 105.63% at 100% 97.58%, #DFEDFF 0%, rgba(223, 237, 255, 0.00) 100%), #EDF2F7",
        offerRibbon: {
          content: "Special offer!",
          background: "#FDD746",
          color: "#102641",
          variant: "smalltext"
        },
        image: {
          url: {
            mobile: "/assets/content/ar3wygh8lg/web/spoMflip.png",
            tablet: "/assets/content/7lmucxbbva/web/sport1TV.png",
            default: "/assets/content/7lmucxbbva/web/sport1TV.png"
          },
          alt: "MySports-Channel-Banner",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%"
          },
          height: {
            xs: "auto",
            sm: "auto",
            md: "auto"
          },
          objectFit: {
            xs: "cover",
            sm: "cover",
            md: "cover"
          }
        },
        mobileImagePosition: "left",
        title: {
          content: "[package_name]®",
          color: "#102641",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "The sports you want, including ESPN Unlimited — no filler, just action.",
          color: "#102641",
          variant: "smalltext",
          fontSize: "14px"
        },
        strikeThroughPrice: {
          content: "$[regular_price]/mo.",
          color: "#000000",
          variant: "smalltext",
          fontSize: "14px",
          textDecoration: "line-through"
        },
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#102641",
          duration: "/mo. for first [promo_duration] mos*",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#102641"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/mysports",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      backCard: {
        borderRadius: "24px 24px 0 0",
        background: "radial-gradient(circle farthest-corner at bottom right, #000000, #0062DB)",
        offerRibbon: {
          content: "Special offer!",
          background: "#FDD746",
          color: "#2B250C",
          variant: "smalltextmedium"
        },
        title: {
          content: "[package_name]®",
          color: "#FFFFFF",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "",
          color: "#FFFFFF",
          variant: "smalltext",
          fontSize: "14px",
          cta: {
            label: "[channel_count]+ channels",
            modalType: "iframe",
            modalData: { url: "/channel-pack-lineup/modal?pkg=mysports" },
            variant: "uxlink",
            sx: {
              color: "#FFFFFF",
              fontSize: "14px",
              textDecoration: "underline",
              p: 0
            }
          }
        },
        images: [
          {
            url: {
              mobile: "/assets/content/oszugm1dyh/svg/GrowCard-Logos-MBL-MySports-2x-v2.svg",
              tablet: "/assets/content/w2sau5vso2/svg/GrowCard-Logos-DSK-MySports-2x-v2.svg",
              default: "/assets/content/w2sau5vso2/svg/GrowCard-Logos-DSK-MySports-2x-v2.svg"
            },
            alt: "MySports-Channel-Banner",
            width: {
              xs: "78%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "contain",
              sm: "contain",
              md: "contain"
            },
            padding: {
              xs: "0 16px",
              sm: "0 16px",
              md: "0 24px"
            },
            display: {
              xs: "flex",
              sm: "flex",
              md: "flex"
            }
          },
          {
            url: {
              mobile: "/assets/content/mkf79fatad/web/sports1.png",
              tablet: "/assets/content/mkf79fatad/web/sports1.png",
              default: "/assets/content/mkf79fatad/web/sports1.png"
            },
            alt: "MySports-Channel-Banner",
            width: {
              xs: "100%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "contain",
              sm: "contain",
              md: "contain"
            },
            display: {
              xs: "none",
              sm: "flex",
              md: "flex"
            }
          }
        ],
        strikeThroughPrice: {
          content: "$[regular_price]/mo.",
          color: "#FFFFFF",
          variant: "smalltext",
          fontSize: "14px",
          textDecoration: "line-through"
        },
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#FFFFFF",
          duration: "/mo. for first [promo_duration] mos*",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#FFFFFF"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/mysports",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      compareBox: {
        content: "Compare",
        color: "#566578",
        selectedColor: "#0062DB",
        background: "#FAFCFF",
        variant: "smalltextmedium",
        fontSize: "14px !important"
      }
    },
    {
      config: {
        id: "ATT_TV_MYKIDS",
        queryparam: "mykids",
        defaultCard: "front"
      },
      frontCard: {
        background: "radial-gradient(78.39% 105.63% at 100% 97.58%, #DFEDFF 0%, rgba(223, 237, 255, 0.00) 100%), #EDF2F7",
        image: {
          url: {
            mobile: "/assets/content/zqzoywkcax/web/kidMflip.png",
            tablet: "/assets/content/dxemq371lg/web/kidTV.png",
            default: "/assets/content/dxemq371lg/web/kidTV.png"
          },
          alt: "MyKids-Channel-Banner",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%"
          },
          height: {
            xs: "auto",
            sm: "auto",
            md: "auto"
          },
          objectFit: {
            xs: "cover",
            sm: "cover",
            md: "cover"
          }
        },
        mobileImagePosition: "right",
        title: {
          content: "[package_name]™",
          color: "#102641",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "Over 10 kid-focused family-friendly live TV, and Disney+ too!",
          color: "#102641",
          variant: "smalltext",
          fontSize: "14px"
        },
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#102641",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#102641"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/mykids",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      backCard: {
        borderRadius: "24px 24px 0 0",
        background: "radial-gradient(circle farthest-corner at top left, #075156, #121212)",
        title: {
          content: "[package_name]™",
          color: "#FFFFFF",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "",
          color: "#FFFFFF",
          variant: "smalltext",
          fontSize: "14px",
          cta: {
            label: "[channel_count]+ channels",
            modalType: "iframe",
            modalData: { url: "/channel-pack-lineup/modal?pkg=mykids" },
            variant: "uxlink",
            sx: {
              color: "#FFFFFF",
              fontSize: "14px",
              textDecoration: "underline",
              p: 0
            }
          }
        },
        images: [
          {
            url: {
              mobile: "/assets/content/nvnu9fa8e5/svg/GrowCard-Logos-MBL-MyKids-2x.svg?u=pw0kir",
              tablet: "/assets/content/0uaduaxn6m/svg/GrowCard-Logos-DSK-MyKids-2x.svg?u=pw0kir",
              default: "/assets/content/0uaduaxn6m/svg/GrowCard-Logos-DSK-MyKids-2x.svg?u=pw0kir"
            },
            alt: "MyKids-Channel-Banner",
            width: {
              xs: "78%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "contain",
              sm: "contain",
              md: "contain"
            },
            padding: {
              xs: "0 16px",
              sm: "0 16px",
              md: "0 24px"
            },
            display: {
              xs: "flex",
              sm: "flex",
              md: "flex"
            }
          },
          {
            url: {
              mobile: "/assets/content/pkppajuwwa/web/kids.png",
              tablet: "/assets/content/pkppajuwwa/web/kids.png",
              default: "/assets/content/pkppajuwwa/web/kids.png"
            },
            alt: "MyKids-Channel-Banner",
            width: {
              xs: "100%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "cover",
              sm: "cover",
              md: "cover"
            },
            display: {
              xs: "none",
              sm: "flex",
              md: "flex"
            }
          }
        ],
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#FFFFFF",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#FFFFFF"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/mykids",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        bodyText: {
          content: "",
          color: "#FFFFFF",
          variant: "body2"
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      compareBox: {
        content: "Compare",
        color: "#566578",
        selectedColor: "#0062DB",
        background: "#FAFCFF",
        variant: "smalltextmedium",
        fontSize: "14px !important"
      }
    },
    {
      config: {
        id: "ATT_TV_MIESPANOL",
        queryparam: "miespanol",
        defaultCard: "front"
      },
      frontCard: {
        background: "radial-gradient(78.39% 105.63% at 100% 97.58%, #DFEDFF 0%, rgba(223, 237, 255, 0.00) 100%), #EDF2F7",
        image: {
          url: {
            mobile: "/assets/content/h2xruas4u3/web/espMflip.png",
            tablet: "/assets/content/jml60iiqos/web/espTV.png",
            default: "/assets/content/jml60iiqos/web/espTV.png"
          },
          alt: "MiEspañol-Channel-Banner",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%"
          },
          height: {
            xs: "auto",
            sm: "auto",
            md: "auto"
          },
          objectFit: {
            xs: "cover",
            sm: "cover",
            md: "cover"
          }
        },
        mobileImagePosition: "left",
        title: {
          content: "[package_name]®",
          color: "#102641",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "The best in Spanish-language entertainment— from novelas to fútbol and more.",
          color: "#102641",
          variant: "smalltext",
          fontSize: "14px"
        },
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#102641",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#102641"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/miespanol",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      backCard: {
        background: "radial-gradient(circle farthest-corner at top left, #604000, #121212)",
        title: {
          content: "[package_name]®",
          color: "#FFFFFF",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "",
          color: "#FFFFFF",
          variant: "smalltext",
          fontSize: "14px",
          cta: {
            label: "[channel_count]+ channels",
            modalType: "iframe",
            modalData: { url: "/channel-pack-lineup/modal?pkg=miespanol" },
            variant: "uxlink",
            sx: {
              color: "#FFFFFF",
              fontSize: "14px",
              textDecoration: "underline",
              p: 0
            }
          }
        },
        images: [
          {
            url: {
              mobile: "/assets/content/gv0sslmxuq/svg/GrowCard-Logos-MBL-MiEsp-2x-v2.svg",
              tablet: "/assets/content/yr9fixgllf/svg/GrowCard-Logos-DSK-MiEsp-2x-v2.svg",
              default: "/assets/content/yr9fixgllf/svg/GrowCard-Logos-DSK-MiEsp-2x-v2.svg"
            },
            alt: "MiEspañol-Channel-Banner",
            width: {
              xs: "78%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "cover",
              sm: "cover",
              md: "cover"
            },
            padding: {
              xs: "0 16px",
              sm: "0 16px",
              md: "0 24px"
            },
            display: {
              xs: "flex",
              sm: "flex",
              md: "flex"
            }
          },
          {
            url: {
              mobile: "/assets/content/vjbtkekucq/web/espanol.png",
              tablet: "/assets/content/vjbtkekucq/web/espanol.png",
              default: "/assets/content/vjbtkekucq/web/espanol.png"
            },
            alt: "MiEspañol-Channel-Banner",
            width: {
              xs: "100%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "cover",
              sm: "cover",
              md: "cover"
            },
            display: {
              xs: "none",
              sm: "flex",
              md: "flex"
            }
          }
        ],
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#FFFFFF",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#FFFFFF"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/miespanol",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      compareBox: {
        content: "Compare",
        color: "#566578",
        selectedColor: "#0062DB",
        background: "#FAFCFF",
        variant: "smalltextmedium",
        fontSize: "14px !important"
      }
    },
    {
      config: {
        id: "ATT_TV_MYNEWS_LOCALS",
        queryparam: "mynews",
        defaultCard: "front"
      },
      frontCard: {
        background: "radial-gradient(78.39% 105.63% at 100% 97.58%, #DFEDFF 0%, rgba(223, 237, 255, 0.00) 100%), #EDF2F7",
        image: {
          url: {
            mobile: "/assets/content/jbbcbolgns/web/newMflip.png",
            tablet: "/assets/content/1dv5kt8kxh/web/newTV.png",
            default: "/assets/content/1dv5kt8kxh/web/newTV.png"
          },
          alt: "MyNews-Channel-Banner",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%"
          },
          height: {
            xs: "auto",
            sm: "auto",
            md: "auto"
          },
          objectFit: {
            xs: "cover",
            sm: "cover",
            md: "cover"
          }
        },
        mobileImagePosition: "right",
        title: {
          content: "[package_name]®",
          color: "#102641",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "Stay informed with top national, global, and local news sources.",
          color: "#102641",
          variant: "smalltext",
          fontSize: "14px"
        },
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#102641",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#102641"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/mynews",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      backCard: {
        background: "radial-gradient(circle farthest-corner at bottom right, #1F2298, #121212)",
        title: {
          content: "[package_name]®",
          color: "#FFFFFF",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "",
          color: "#FFFFFF",
          variant: "smalltext",
          fontSize: "14px",
          cta: {
            label: "[channel_count]+ channels",
            modalType: "iframe",
            modalData: { url: "/channel-pack-lineup/modal?pkg=mynews" },
            variant: "uxlink",
            sx: {
              color: "#FFFFFF",
              fontSize: "14px",
              textDecoration: "underline",
              p: 0
            }
          }
        },
        images: [
          {
            url: {
              mobile: "/assets/content/wecv2telcr/svg/6922201-GrowCrad-Logos-MBL-MyNews-2x.svg?u=pw0kir",
              tablet: "/assets/content/qvcl6r9dm2/svg/6922201-GrowCrad-Logos-DSK-MyNews-2x.svg?u=pw0kir",
              default: "/assets/content/qvcl6r9dm2/svg/6922201-GrowCrad-Logos-DSK-MyNews-2x.svg?u=pw0kir"
            },
            alt: "MyNews-Channel-Banner",
            width: {
              xs: "78%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "cover",
              sm: "cover",
              md: "cover"
            },
            padding: {
              xs: "0 16px",
              sm: "0 16px",
              md: "0 24px"
            },
            display: {
              xs: "flex",
              sm: "flex",
              md: "flex"
            }
          },
          {
            url: {
              mobile: "/assets/content/oszugm1dyh/svg/GrowCard-Logos-MBL-MySports-2x-v2.svg",
              tablet: "/assets/content/w2sau5vso2/svg/GrowCard-Logos-DSK-MySports-2x-v2.svg",
              default: "/assets/content/w2sau5vso2/svg/GrowCard-Logos-DSK-MySports-2x-v2.svg"
            },
            alt: "MyNews-Channel-Banner",
            width: {
              xs: "78%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "contain",
              sm: "contain",
              md: "contain"
            },
            padding: {
              xs: "0 16px",
              sm: "0 16px",
              md: "0 24px"
            },
            display: {
              xs: "flex",
              sm: "flex",
              md: "flex"
            }
          },
          {
            url: {
              mobile: "/assets/content/x6irdnsnlc/web/news.png",
              tablet: "/assets/content/x6irdnsnlc/web/news.png",
              default: "/assets/content/x6irdnsnlc/web/news.png"
            },
            alt: "MyNews-Channel-Banner",
            width: {
              xs: "100%",
              sm: "100%",
              md: "100%"
            },
            height: {
              xs: "auto",
              sm: "auto",
              md: "auto"
            },
            objectFit: {
              xs: "cover",
              sm: "cover",
              md: "cover"
            },
            display: {
              xs: "none",
              sm: "flex",
              md: "flex"
            }
          }
        ],
        priceText: {
          content: "$[offer_price]",
          variant: "body1medium",
          color: "#FFFFFF",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#FFFFFF"
          }
        },
        cta: {
          label: "Shop now",
          href: "/genre-packs/mynews",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        },
        legalTextNoOffer: {
          content: "New customers only. Pricing subject to change. Additional taxes and fees apply. Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      },
      compareBox: {
        content: "Compare",
        color: "#566578",
        selectedColor: "#0062DB",
        background: "#FAFCFF",
        variant: "smalltextmedium",
        fontSize: "14px !important"
      }
    },
    {
      config: {
        id: "",
        queryparam: "",
        defaultCard: "front"
      },
      frontCard: {
        background: "radial-gradient(78.39% 105.63% at 100% 97.58%, #DFEDFF 0%, rgba(223, 237, 255, 0.00) 100%), #EDF2F7",
        image: {
          url: {
            mobile: "/assets/content/t2ozc6nzif/web/pkgTV.png",
            tablet: "/assets/content/t2ozc6nzif/web/pkgTV.png",
            default: "/assets/content/t2ozc6nzif/web/pkgTV.png"
          },
          alt: "Streaming packages-Channel-Banner",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%"
          },
          height: {
            xs: "auto",
            sm: "auto",
            md: "auto"
          },
          objectFit: {
            xs: "cover",
            sm: "cover",
            md: "cover"
          }
        },
        mobileImagePosition: "top",
        title: {
          content: "Streaming packages",
          color: "#102641",
          variant: "subhead2medium"
        },
        subHeading: {
          content: "Get up to 185+ live and local channels, premium networks, and sports—no annual contract required.",
          color: "#102641",
          variant: "smalltext",
          fontSize: "14px",
          spanText: {
            content: "Number/type of channels vary based on package selection.",
            variant: "smalltext",
            color: "#555555",
            fontSize: "11px !important"
          }
        },
        strikeThroughPrice: {
          content: "Starting at",
          color: "#000000",
          variant: "smalltext",
          fontSize: "14px"
        },
        priceText: {
          content: "$89.99",
          variant: "body1medium",
          color: "#102641",
          spanText: {
            content: "/mo. +tax*",
            variant: "smalltext",
            color: "#102641"
          }
        },
        cta: {
          label: "Shop now",
          href: "/packages",
          color: "#FFFFFF",
          buttonType: "primary",
          size: "small",
          background: "#006DFF",
          mode: "light",
          hover: {
            color: "#FFFFFF !important",
            background: "#0062E3 !important",
            border: ""
          }
        },
        legalText: {
          content: "Cancel anytime.",
          variant: "body2",
          component: "div"
        }
      }
    }
  ],
  comparePkgTray: {
    cta1: {
      content: "Compare",
      targetUrl: "/compare-packages/?type=genre&cmpPkg="
    },
    cta2: {
      content: "Clear all"
    },
    title: {
      content: "Choose up to 3 packages to compare."
    },
    subTitle: {
      content: "Compare packages"
    },
    alert: [
      {
        severity: "warning",
        description: {
          content: "Maximum of 3 packages can be compared."
        }
      }
    ],
    compareText: {
      theme: "light",
      content: "Compare"
    },
    subHeading1: {
      content: "Genre Packs",
      displayPkgType: "genre",
      chips: [
        {
          packageId: "ATT_TV_MYSPORTS",
          queryparam: "mysports",
          packageName: "MySports",
          price: "$44.99",
          channels: "20+ ch.",
          type: "genre"
        },
        {
          packageId: "ATT_TV_MYENTERTAINMENT",
          queryparam: "myentertainment",
          packageName: "MyEntertainment",
          price: "$34.99",
          channels: "60+ ch.",
          type: "genre"
        },
        {
          packageId: "ATT_TV_MYNEWS_LOCALS",
          queryparam: "mynews",
          packageName: "MyNews",
          price: "$39.99",
          channels: "10+ ch.",
          type: "genre"
        },
        {
          packageId: "ATT_TV_MYKIDS",
          queryparam: "mykids",
          packageName: "MyKids",
          price: "$19.99",
          channels: "10+ ch.",
          type: "genre"
        },
        {
          packageId: "ATT_TV_MIESPANOL",
          queryparam: "miespanol",
          packageName: "MiEspañol",
          price: "$34.99",
          channels: "60+ ch.",
          type: "genre"
        }
      ]
    },
    subHeading2: {
      content: "Compare with Streaming packages",
      displayPkgType: "internet",
      _editable: '<!--#storyblok#{"name": "content_uf", "space": "1013471", "uid": "c132f41c-30d4-4f7c-b17e-d3377b20222d", "id": "166431037259529"}-->',
      chips: [
        {
          packageId: "ATT_TV_ENTERTAINMENT",
          queryparam: "entertainment",
          packageName: "ENTERTAINMENT",
          price: "$59.99",
          channels: "90+ ch.",
          type: "internet"
        },
        {
          packageId: "ATT_TV_CHOICE",
          queryparam: "choice",
          packageName: "CHOICE™",
          price: "$64.99",
          channels: "125+ ch.",
          type: "internet"
        },
        {
          packageId: "ATT_TV_ULTIMATE",
          queryparam: "ultimate",
          packageName: "ULTIMATE",
          price: "$89.99",
          channels: "160+ ch.",
          type: "internet"
        },
        {
          packageId: "ATT_TV_PREMIER",
          queryparam: "premier",
          packageName: "PREMIER™",
          price: "$129.99",
          channels: "185+ ch.",
          type: "internet"
        },
        {
          packageId: "ATT_TV_OPTIMO_MAS",
          queryparam: "optimomas",
          packageName: "ÓPTIMO MÁS™",
          price: "$59.99",
          channels: "110+ ch.",
          type: "internet"
        }
      ]
    },
    subHeading3: {
      content: "Multi Pack",
      offerRibbon: {
        content: "New!",
        background: "#FDD746",
        _editable: '<!--#storyblok#{"name": "content_uf", "space": "1013471", "uid": "8101bfc7-6b37-498f-89e6-807a5a8ad838", "id": "166431037259529"}-->'
      },
      displayPkgType: "multi",
      _editable: '<!--#storyblok#{"name": "content_uf", "space": "1013471", "uid": "87a00c8b-93f2-4703-bd16-b781a3747abd", "id": "166431037259529"}-->',
      chips: [
        {
          packageId: "ATT_TV_MYSPORTS_MYNEWS",
          queryparam: "mysportsmynewsduo",
          packageName: "MySports & MyNews Duo",
          price: "$59.99",
          channels: "30+ ch.",
          type: "genre",
          subType: "multi"
        }
      ]
    },
    isCompareEnabled: true,
    maxSelectedPackages: "3",
    _editable: '<!--#storyblok#{"name": "comparePkgTray", "space": "1013471", "uid": "46ad29b2-2808-496a-b692-361433294a65", "id": "166431037259529"}-->'
  }
};
